import {Component, EventEmitter, Injector, OnInit} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {ParameterService} from "../../_services/parameter.service";
import {AdminUserDialog} from "./modals/admin-user.dialog";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {ScorecardService} from "../../_services/scorecard.service";

@Component({
    selector: 'admin-assessment',
    templateUrl: './assessment.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class AssessmentComponent extends BaseComponentDirective implements OnInit {
    public result = new EventEmitter();
    public form: FormGroup;
    public competitionLevels: any = {};
    user: any = null;
    scorecards: any[] = [];
    wideMatch: any[] = [];
    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private scorecardService: ScorecardService,
        private parameterService: ParameterService
    ) {
        super(injector);
        this.form = this.formBuilder.group({
            userId: [null, [Validators.required]],
            userName: [null, [Validators.required]],
            assessmentDate: [null, [Validators.required]],
            competitionLevel: [null, [Validators.required]],
            summary: [null, [Validators.required]]
        });
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.competitionLevels = await this.parameterService.getParameterByName("COMPETITION_LEVEL");

    }

    openMember() {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const dialog = this.dialog.open(AdminUserDialog, {
            width: dialogWidth,
            maxWidth: '100%'
        });

        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.user = r;
                this.form.controls.userId.setValue(r.id);
                this.form.controls.userName.setValue(r.fullName + ' - ' + r.email);
            }
        })
    }

    addScorecard() {
        this.scorecards.push({challengeName: '', accuracy: 0, competency: 0, rankLevel: ''})
    }

    deleteScorecard(scorecard: any, index: number) {
        const dialog = this.dialog.open(ConfirmationDialog, {
            data: {
                message: `Confirm Deletion of ${(scorecard.challengeName)? scorecard.challengeName: 'empty'}` ,
                subMessage: 'Are you sure want to delete this row of scorecard?',
                buttonOkLabel: 'Ok, Delete',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        })
        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.scorecards.splice(index, 1);
            }
        })

    }

    deleteWideMatch(wideMatch: any, index: number) {
        const dialog = this.dialog.open(ConfirmationDialog, {
            data: {
                message: `Confirmation Deletion of ${(wideMatch.challengeName)? wideMatch.challengeName: 'empty'}`,
                subMessage: 'Are you sure want to delete this row of wide-match?',
                buttonOkLabel: 'Ok, Delete',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        })
        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.wideMatch.splice(index, 1);
            }
        })

    }

    addWideMatch() {
        this.wideMatch.push({challengeName: '', averageAccuracy: 0, averageCompetency: 0});
    }

    resetForm() {
        const dialog = this.dialog.open(ConfirmationDialog, {
            data: {
                message: `Confirmation Reset Form`,
                subMessage: 'Are you sure want to reset the form?',
                buttonOkLabel: 'Yes, Reset',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        })
        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.form.reset();
                this.form.markAsPristine();
                this.form.markAsUntouched();
                this.scorecards = [];
                this.wideMatch = [];
            }
        })

    }

    save() {
        const validation = this.check(this.form);
        if(validation) {
            this.showAlertDark('Warning', '', 'Please complete all required fields.');
            return;
        }

        const dialog = this.dialog.open(ConfirmationDialog, {
            data: {
                message: `Add New Assessment for Member ${this.user.fullName} (${this.user.email})`,
                subMessage: 'Are you sure want to save this assessment?',
                buttonOkLabel: 'Save',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        });
        dialog.componentInstance.result.subscribe(r => {
            if (r) {
                const payload = {
                    assessmentDate: this.date.momentToDbDate(this.form.controls.assessmentDate.value),
                    competitionLevel: this.form.controls.competitionLevel.value,
                    userId: this.form.controls.userId.value,
                    summary: this.form.controls.summary.value,
                    individuals: this.scorecards,
                    wideMatches: this.wideMatch
                }

                this.scorecardService.save(payload).then(_ => {
                    this.showAlertDark('Assessment', '', 'Assessment has been added successfully');
                })
            }
        });
    }
}
